import SeniorWellnessPlan from "./SeniorWellnessPlan.component";
export default SeniorWellnessPlan;
